/**
 * Which install definition applies to a given route.
 *
 * The published app serves a platform manifest whose start_url is the site root
 * and whose scope covers the whole origin. iOS Safari honours start_url at the
 * moment a shortcut is saved, so while that manifest is attached every "Add to
 * Home Screen" launches the homepage rather than the page it was saved from.
 *
 * Internal screens therefore swap it out: either for a manifest of their own,
 * or for nothing at all — with no manifest present Safari falls back to the
 * page's own URL, which is exactly the deep link we want.
 *
 * Returns null for public routes, where the platform manifest is left alone so
 * the storefront stays installable and branded.
 */
export function installMetaFor(pathname) {
  // Wall-mounted displays carry their own manifest so a saved shortcut launches
  // straight into the screen it was saved from. Checked before the generic
  // /leaderboard and /live matches below so they can never shadow these.
  if (pathname === '/venue/leaderboard') {
    return { manifest: '/venue-leaderboard.webmanifest', title: 'MR Leaderboard' };
  }
  if (pathname === '/venue/live') {
    return { manifest: '/venue-live.webmanifest', title: 'MR Live' };
  }
  if (pathname === '/venue/kiosk') {
    return { manifest: '/venue-manifest.webmanifest', title: 'MR Kiosk' };
  }
  if (pathname === '/venue/pos' || pathname === '/pos') {
    return { manifest: '/venue-pos.webmanifest', title: 'MR POS' };
  }
  if (pathname === '/leaderboard') {
    return { manifest: null, title: 'MR Leaderboard' };
  }
  if (pathname === '/live' || pathname.startsWith('/live/')) {
    return { manifest: null, title: 'MR Live' };
  }
  if (pathname === '/admin' || pathname.startsWith('/admin/')) {
    return { manifest: null, title: 'MR Admin' };
  }
  return null;
}